import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useLanguageStore from '@stores/languageStore';

const DocumentTitle = () => {
  const { t } = useTranslation();
  const { language } = useLanguageStore();

  useEffect(() => {
    const appName = t('common.appName');
    document.title = appName;
  }, [language, t]);

  return null;
};

export default DocumentTitle;

